module.exports = __webpack_public_path__ + "img/branch.f26d239f.svg";